module.exports = __webpack_public_path__ + "img/便利店商城.f5852ab4.png";